const BOOKMARK_WIDTH = 6;
const SCRUB_WIDTH = 2;

import { Vector3 } from "three";

export class TimeBar {
    constructor(name, domParent, animationInterface, interfaces) {
        this.name = name;
        this.div = document.createElement('div');
        this.div.id = name.replaceAll(" ","-") + "-div";
        this.div.classList.add("elementDiv");
        this.id = name.replaceAll(" ","-");
        this.domParent = document.getElementById(domParent);
        this.endBreak = document.createElement("BR");
        this.domParent.appendChild(this.div);
        this.div.classList.add("CanvasDiv")
        this.animationInterface = animationInterface;
        this.interfaces = interfaces;
        this.wasHoverCamera = false;
        this.saveView;
        this.clickable = true;

        this.canvas = document.createElement('canvas');
        this.canvas.id = name.replaceAll(" ","-") + "-canvas";
        this.canvas.width = 2000;
        this.canvas.height = 1000;
        this.ctx = this.canvas.getContext("2d");

        this.div.appendChild(this.canvas);

        this.mouseX = 0;
        this.mouseY = 0;
        this.isMouseDown = false
        this.canvas.onmousemove = (event) => {
            let rect = this.canvas.getBoundingClientRect();
            this.mouseX = (event.clientX - rect.left) * (this.canvas.width / rect.width);
            this.mouseY = (event.clientY - rect.top) * (this.canvas.height / rect.height);
            this.updateSlider()
        }
        this.canvas.onmouseleave = (event) => {
            this.mouseX = this.mouseY = -1;
        }
        this.canvas.onmousedown = (event) => {
            this.click();
            this.isMouseDown = true
        }
        this.canvas.onmouseup = (event) => {
            this.isMouseDown = false
        }

        // timevalues
        this.startTime = 0;
        this.endTime = 1;
        this.maxTime = 1;
        this.currTime = 0;
        this.bookmarks = [];
        this.currBookmarkList;

        this.updateCanvas();

        // key mapping
        this.keyMap = new Map();
        let activateKey = (e) => {
            this.keyMap.set(e.key, true)
        }
        let deactivateKey = (e) => {
            this.keyMap.set(e.key, false)
        }
        document.addEventListener('keydown', activateKey);
        document.addEventListener('keyup', deactivateKey);
        this.setToolTip(this.interfaces.tooltips.timebar, "bottomToolTip");
    }

    removeDiv() {
        this.div.remove();
    }

    addDiv() {
        this.domParent.appendChild(this.div);
    }

    addBookmark(motionName, time) {
        let bookmarkList = this.bookmarks.find(list => list.name === motionName);
        if(!bookmarkList) {
            bookmarkList = new BookmarkList(motionName);
            this.bookmarks.push(bookmarkList);
        }

        bookmarkList.addBookmark(time);

        // sort bookmarkList
        bookmarkList.bookmarks.sort((mark1, mark2) => {
            return mark1.time - mark2.time
        })
    }

    addCameraMark(motionName, time) {
        let bookmarkList = this.bookmarks.find(list => list.name === motionName);
        if(!bookmarkList) {
            bookmarkList = new BookmarkList(motionName);
            this.bookmarks.push(bookmarkList);
        }

        bookmarkList.addCameraMark(time, this.interfaces.controls);

        // sort cameraList
        bookmarkList.cameraMarks.sort((mark1, mark2) => {
            return mark1.time - mark2.time
        })
    }

    setMotion(motionName) {
        this.currBookmarkList = this.bookmarks.find(list => list.name === motionName);
        if(!this.currBookmarkList) {
            this.currBookmarkList = new BookmarkList(motionName);
            this.bookmarks.push(this.currBookmarkList);
        }
    }

    // if -1, don't change time
    updateRange(start, end, maxTime) {
        if(start != -1) {
            this.startTime = start;
        }
        if(end != -1) {
            this.endTime = end;
        }
        if(maxTime != -1) {
            this.maxTime = maxTime;
        }
        this.updateCanvas();
    }

    updateTime(time) {
        this.currTime = time;
    }

    updateCanvas() {
        // const BOOKMARK_WIDTH = 6;
        this.animationInterface.hideGhost();

        this.ctx.fillStyle = "white";
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

        let startPos = (this.startTime/this.maxTime) * this.canvas.width;
        let barWidth = ((this.endTime/this.maxTime) * this.canvas.width) - startPos;
        this.ctx.fillStyle = "#78c2d6";
        this.ctx.fillRect(startPos, 0, barWidth, this.canvas.height);
        
        if(this.currBookmarkList) {
            this.currBookmarkList.bookmarks.forEach(mark => {
                let pos = (mark.time/this.maxTime) * this.canvas.width;
                if(this.mouseX > pos - (BOOKMARK_WIDTH / 2) && this.mouseX < pos + (BOOKMARK_WIDTH / 2) && this.mouseY > 0 && this.mouseY < this.canvas.height) {
                    this.ctx.fillStyle = "#ff0000";
                    this.animationInterface.showGhost(mark.time);
                } else {
                    this.ctx.fillStyle = "#fcbe12";
                }
                this.ctx.fillRect(pos - BOOKMARK_WIDTH / 2, 0, BOOKMARK_WIDTH, this.canvas.height/2)
            });

            let hovering = false;
            let hoveredCameraMark;
            this.currBookmarkList.cameraMarks.forEach(mark => {
                let pos = (mark.time/this.maxTime) * this.canvas.width;
                if(this.mouseX > pos - (BOOKMARK_WIDTH / 2) && this.mouseX < pos + (BOOKMARK_WIDTH / 2) && this.mouseY > 0 && this.mouseY < this.canvas.height) {
                    this.ctx.fillStyle = "#ff0000";
                    hoveredCameraMark = mark;
                    hovering = true;
                } else {
                    this.ctx.fillStyle = "#18ad0a";
                }
                this.ctx.fillRect(pos - BOOKMARK_WIDTH / 2, this.canvas.height/2, BOOKMARK_WIDTH, this.canvas.height/2)
            });

            if(hovering != this.wasHoverCamera && this.animationInterface.autoCameraCheck.checkbox.checked) {
                if(this.wasHoverCamera) {
                    this.resetCamera();
                } else {
                    this.saveCamera();
                    this.updateControls(hoveredCameraMark);
                }
                this.wasHoverCamera = hovering;
            }
        }

        let sliderPos = (this.currTime/this.maxTime) * this.canvas.width;
        this.ctx.fillStyle = "#c96512";
        this.ctx.fillRect(sliderPos-SCRUB_WIDTH/2, 0, SCRUB_WIDTH, this.canvas.height);
    }

    click() {
        if(!this.clickable) {
            return;
        }
        else if(this.currBookmarkList) {
            // bookmarks
            for(let i = 0; i < this.currBookmarkList.bookmarks.length; i++) {
                let pos = (this.currBookmarkList.bookmarks[i].time/this.maxTime) * this.canvas.width;
                if(this.mouseX > pos - (BOOKMARK_WIDTH / 2) && this.mouseX < pos + (BOOKMARK_WIDTH / 2) && this.mouseY > 0 && this.mouseY < this.canvas.height) {
                    if(this.keyMap.get("Shift")) {
                        this.currBookmarkList.bookmarks.splice(i, 1);
                    } else {
                        this.animationInterface.updateTime(this.currBookmarkList.bookmarks[i].time);
                    }
                }
            }
            // camera marks
            for(let i = 0; i < this.currBookmarkList.cameraMarks.length; i++) {
                let pos = (this.currBookmarkList.cameraMarks[i].time/this.maxTime) * this.canvas.width;
                if(this.mouseX > pos - (BOOKMARK_WIDTH / 2) && this.mouseX < pos + (BOOKMARK_WIDTH / 2) && this.mouseY > 0 && this.mouseY < this.canvas.height) {
                    if(this.keyMap.get("Shift")) {
                        this.currBookmarkList.cameraMarks.splice(i, 1);
                    } else {
                        // this.animationInterface.updateTime(this.currBookmarkList.cameraMarks[i].time);
                        // if(this.animationInterface.autoCameraCheck.checkbox.checked) {
                        //     this.updateControls(this.currBookmarkList.cameraMarks[i]);
                        // }
                        this.updateControls(this.currBookmarkList.cameraMarks[i]);
                        this.wasHoverCamera = false;
                    }
                }
            }
        }
        this.updateSlider();
    }

    updateSlider() {
        if(!this.clickable) {
            return
        }
        if(this.isMouseDown) {
            this.animationInterface.sliderUpdate((this.mouseX / this.canvas.width) * this.maxTime)
        }
    }

    saveCamera() {
        this.saveView = {
            cameraPos: this.interfaces.controls.object.position.clone(),
            cameraLookAt: this.interfaces.controls.target.clone(),
            cameraZoom: this.interfaces.controls.object.zoom
        }
    }

    resetCamera() {
        if(this.saveView) {
            this.updateControls(this.saveView);
        }
    }

    updateControls(cameraMark) {
        // copied from orbit controls reset() method
        let pos = cameraMark.cameraPos;
        this.interfaces.controls.object.position.copy(pos);
        let lookAt = cameraMark.cameraLookAt;
        this.interfaces.controls.target.copy(lookAt);
        this.interfaces.controls.object.zoom = cameraMark.cameraZoom;
        this.interfaces.controls.object.updateProjectionMatrix();
        this.interfaces.controls.dispatchEvent({ type: 'change' });
        this.interfaces.controls.update();
    }

    getBookmarkTimes() {
        return this.currBookmarkList.bookmarks;
    }

    getBookmarkList() {
        return this.currBookmarkList.cameraMarks;
    }

    getAllBookmarkLists() {
        return this.bookmarks;
    }

    setToolTip(text, section) {
        if(!this.div.classList.contains("tooltip")) {
            this.div.classList.add("tooltip")
        }
        let span = document.createElement("span");
        span.classList.add("tooltiptext");
        span.classList.add(section);
        span.innerHTML = text;
        this.div.appendChild(span);
    }

    toggleClickable(value) {
        this.clickable = value
    }
}

class BookmarkList {
    constructor(name) {
        this.name = name;
        this.bookmarks = [];
        this.cameraMarks = [];
    }

    addBookmark(time) {
        this.bookmarks.push({
            time: time
        });
    }

    addCameraMark(time, controls) {
        this.cameraMarks.push({
            time: time,
            cameraPos: controls.object.position.clone(),
            cameraLookAt: controls.target.clone(),
            cameraZoom: controls.object.zoom
        });
    }
}